import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { CutNumberPipe } from '../../../pipes/cut-number.pipe';

export interface WelcomeBonusDialogData {
  surveyId: number;
  rewardAmount: string | number;
}

@Component({
  selector: 'app-dialog-welcome-bonus',
  imports: [
    MatIcon,
    MatDialogClose,
    CutNumberPipe,
  ],
  templateUrl: './dialog-welcome-bonus.component.html',
  styleUrl: './dialog-welcome-bonus.component.scss',
})
export class DialogWelcomeBonusComponent {
  readonly data: WelcomeBonusDialogData = inject(MAT_DIALOG_DATA);
}
